import type { Campaign } from '@feathr/blackbox';
import { EIntegrationTypes } from '@feathr/blackbox';
import { useFlags } from '@feathr/extender/state';

interface IUseCampaignChannelVisibilityReturn {
  showDisplay: boolean;
  showMeta: boolean;
}

/**
 * Derives channel visibility for the reachability breakdown based on
 * the campaign's integrations and the metaV2 feature flag.
 *
 * @param campaign - The campaign to check integrations for.
 * @returns showDisplay and showMeta booleans for TargetAudienceOverview.
 */
function useCampaignChannelVisibility(campaign: Campaign): IUseCampaignChannelVisibilityReturn {
  const { metaV2 } = useFlags();
  const integrations = (campaign.get('integrations') as EIntegrationTypes[] | undefined) ?? [];
  const hasMetaIntegration = integrations.includes(EIntegrationTypes.Meta);
  const hasDisplayIntegration = integrations.includes(EIntegrationTypes.Tradedesk);

  return {
    showDisplay: !metaV2 || hasDisplayIntegration,
    showMeta: !!metaV2 && hasMetaIntegration,
  };
}

export default useCampaignChannelVisibility;
